import { useTranslate } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { OrderLog } from 'types/embedded/orderLog';

type Props = Omit<FunctionFieldProps, 'render'>;

export const OrdersShowLogsIdField: React.FC<Props> = (props) => {
  const translate = useTranslate();

  return (
    <FunctionField
      render={(record: OrderLog) => (
        <Stack alignItems="center" direction="row" gap="8px">
          <Typography color="secondary" sx={{ lineHeight: 1 }} variant="body2">
            {translate('app.orders.logs.eventId')}
          </Typography>
          <Typography>{record?.id}</Typography>
        </Stack>
      )}
      sortable={false}
      {...props}
    />
  );
};
